/*
  Marca "Best Seller" en el selector de perfumes de Arma tu Discovery Box
  (2026-08-20).

  Las opciones las dibuja la app Infinite Options como casillas de texto plano, sin
  identificador de producto, así que la única forma de reconocerlas es por el número
  de Ciro que abre cada texto ("Ciro 01 - ...", "Ciro 12 - ..."). Los nombres no
  sirven: varios difieren del catálogo e incluso traen erratas.

  La app redibuja su bloque, así que se vigila con MutationObserver para volver a
  marcar lo que se haya perdido.
*/
(function () {
  var nodo = document.getElementById('ins-best-seller-datos');
  if (!nodo) return;

  var cfg;
  try {
    cfg = JSON.parse(nodo.textContent);
  } catch (e) {
    return;
  }
  if (!cfg.numeros || !cfg.numeros.length) return;

  function marcar() {
    var app = document.querySelector('.product__info-container .shopify-app-block');
    if (!app) return;

    var casillas = app.querySelectorAll('input[type="checkbox"]');
    for (var i = 0; i < casillas.length; i++) {
      var casilla = casillas[i];
      var etiqueta = casilla.closest('label');
      if (!etiqueta || etiqueta.querySelector('.ins-best-seller')) continue;

      var texto = (etiqueta.textContent || '').replace(/\s+/g, ' ').trim();
      // El cero a la izquierda es opcional: "Ciro 01" y "Ciro 1" son el mismo.
      var coincidencia = texto.match(/^ciro\s*0*(\d+)/i);
      if (!coincidencia) continue;
      if (cfg.numeros.indexOf(Number(coincidencia[1])) === -1) continue;

      var marca = document.createElement('span');
      marca.className = 'ins-best-seller';
      marca.textContent = cfg.texto || 'Best Seller';
      // Justo después de la casilla y antes del nombre, para que encabece la línea.
      etiqueta.insertBefore(marca, casilla.nextSibling);
    }
  }

  function vigilar() {
    var app = document.querySelector('.product__info-container .shopify-app-block');
    if (!app || !window.MutationObserver) return;
    new MutationObserver(function () {
      marcar();
    }).observe(app, { childList: true, subtree: true });
  }

  function iniciar() {
    marcar();
    vigilar();
    // La app puede tardar en pintar sus opciones.
    setTimeout(marcar, 1200);
    setTimeout(marcar, 3000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
